import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import { Link } from "react-router-dom";
import { useConfig } from "../../../context/ConfigContext";
import { formatNumber } from "../../../components/utils/format";

const ServiceHero = () => {
  const config = useConfig();
  const {
    COMPANY_NAME,
    CALL_PHONE_NUMBER,
    PHONE_NUMBER,
    PLANTAS_SOLARES,
    INICIO_DESDE,
    ENERGIA_TOTAL,
  } = config;
  return (
    <section className="relative bg-gradient-to-br from-primary/10 via-white to-secondary/5 pt-24 pb-16">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?ixlib=rb-4.0.3')] bg-cover bg-center opacity-5"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <div className="flex justify-center mb-6">
            <div className="p-4 bg-primary/10 rounded-full">
              <Icon name="Settings" size={48} className="text-primary" />
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-text-primary mb-6">
            Servicios Integrales de
            <span className="block solar-text-gradient">Energía Solar</span>
          </h1>

          <p className="text-xl md:text-2xl text-text-secondary mb-8 leading-relaxed">
            Desde la consulta inicial hasta el mantenimiento a largo plazo,
            {" "}{COMPANY_NAME} te acompaña en cada paso hacia la independencia
            energética
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/calculadora">
              <Button
                variant="default"
                size="lg"
                iconName="Zap"
                iconPosition="left"
                className="bg-cta-orange hover:bg-cta-orange/90"
              >
                Cotizar mi sistema
              </Button>
            </Link>
            <Button
              variant="outline"
              size="lg"
              iconName="Phone"
              iconPosition="left"
              href={`tel:${CALL_PHONE_NUMBER}`}
            >
              Llamar Ahora: {PHONE_NUMBER}
            </Button>
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-3xl font-bold text-primary mb-2">
                {PLANTAS_SOLARES}+
              </div>
              <div className="text-text-secondary">Proyectos Completados</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-primary mb-2">
                {new Date()?.getFullYear() - INICIO_DESDE}+
              </div>
              <div className="text-text-secondary">Años de Experiencia</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-primary mb-2">
                {formatNumber(ENERGIA_TOTAL)}Wh+
              </div>
              <div className="text-text-secondary">Energía Generada</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceHero;
